import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import ThemedSkeleton from "./ThemedSkeleton";
import { Skeleton } from "@/components/ui/skeleton";

function CardLoader({ compact, ...props }) {
  if (compact)
    return (
      <Card {...props}>
        <CardHeader>
          <CardTitle>
            <Skeleton className="h-4" />
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-1">
          <Skeleton className="h-2" />
          <Skeleton className="h-2" />
          <Skeleton className="h-2" />
        </CardContent>
      </Card>
    );
  return (
    <Card {...props}>
      <CardHeader>
        <CardTitle>
          <ThemedSkeleton />
        </CardTitle>
        <CardDescription>
          <ThemedSkeleton className="w-5/6" />
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ThemedSkeleton className="w-11/12" />
        <ThemedSkeleton className="w-4/6" />
        <ThemedSkeleton className="w-5/6" />
        <ThemedSkeleton />
        <ThemedSkeleton className="w-11/12" />
        <ThemedSkeleton />
        <ThemedSkeleton />
      </CardContent>
    </Card>
  );
}

export default CardLoader;
